// extracted by mini-css-extract-plugin
export var note = "products-module--note--3595f";
export var noteLink = "products-module--note-link--c74ed";
export var prodIco = "products-module--prod-ico--6bf23";